import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { InfoIcon, DollarSignIcon } from "lucide-react"
import { CalculatorProvince, CalculatorFormData } from "@/lib/types/calculator"

interface SalaryLocationSectionProps {
  form: CalculatorFormData;
  provinces: CalculatorProvince[];
  provincesLoading: boolean;
  provincesError: string | null;
  onFormChange: (field: string, value: string | boolean) => void;
}

export function SalaryLocationSection({
  form,
  provinces,
  provincesLoading,
  provincesError,
  onFormChange
}: SalaryLocationSectionProps) {
  return (
    <Card>
      <CardContent className="pt-6">
        <h3 className="text-lg font-medium mb-4">Salary & Location</h3>
        <div className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="salary" className="flex items-center">
              Annual Salary
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <InfoIcon className="h-4 w-4 ml-1 text-muted-foreground" />
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>Enter the annual salary before deductions</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </Label>
            <div className="relative">
              <DollarSignIcon className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
              <Input
                id="salary"
                type="number"
                value={form.salary}
                onChange={(e) => onFormChange("salary", e.target.value)}
                className="pl-8"
                placeholder="e.g. 52000"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="province">Province or Territory</Label>
            {provincesLoading ? (
              <div className="text-sm text-muted-foreground">Loading provinces...</div>
            ) : provincesError ? (
              <div className="text-sm text-red-600">{provincesError}</div>
            ) : null}
            <Select value={form.province} onValueChange={(value) => onFormChange("province", value)}>
              <SelectTrigger id="province">
                <SelectValue placeholder="Select province" />
              </SelectTrigger>
              <SelectContent>
                {provinces.map((province) => (
                  <SelectItem key={province.id} value={province.id}>
                    {province.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
      </CardContent>
    </Card>
  );
} 